import React from "react";
import { Box, Flex, IconOnePass, Span, } from "@catchoftheday/cg-components";
export const OnePassExclusiveBadge = ({ compact, containerProps, }) => {
    return (<Flex justifyContent={{ xs: "center", md: "flex-start" }} {...containerProps}>
      <Box display="inline-flex" padding="6px 8px" borderColor="onePass.primary" borderRadius="8px" borderWidth="1px" fontFamily="onePass" alignItems="center" borderStyle="solid" mb="3px" color="onePass.primary" backgroundColor="white">
        <IconOnePass title="OnePass" height={compact ? "11px" : "14px"} width="auto" mr="3px" mb="2px" color="onePass.primary" role="img"/>
        <Span fontWeight="bold" color="onePass.textPrimary" lineHeight="1" fontSize={compact ? "xs" : null}>
          Exclusive
        </Span>
      </Box>
    </Flex>);
};
